<template>
  <div>
    <avue-form ref="form" v-model="formData" :option="formOption">
      <template #errImg>
        <div class="resizable-div">
          <el-image class="image" :src="formData.imgSrc">
            <div slot="error" class="image-slot">
              <!--  异常图片直接不展示  -->
            </div>
          </el-image>
          <vue-draggable-resizable
            class="draggable"
            :class-name="!processed ? 'my-class' : 'success-class'"
            :draggable="false"
            :resizable="false"
            :w="formData.width"
            :h="formData.height"
            :x="formData.problemX1"
            :y="formData.problemY1">
            <el-tag effect="dark" size="mini" :type="!processed ? 'danger' : 'success'" style="border-radius: 0; user-select: none; position: absolute;">
              {{ formData.problemSerial }}
            </el-tag>
          </vue-draggable-resizable>
        </div>
      </template>
      <template #voucher>
        <matrix-upload-no-action
          v-if="!isView"
          accept="image/*"
          multiple
          :limit="5"
          :files.sync="voucherList"
        />
        <template v-else>
          <span v-if="!voucherImg.length">无</span>
          <el-image v-for="url in voucherImg" :key="url" :src="url" :preview-src-list="voucherImg">
            <div slot="error" class="image-slot">
              <!--  异常图片直接不展示  -->
            </div>
          </el-image>
        </template>
      </template>
    </avue-form>
    <span class="avue-dialog__footer">
      <el-button v-if="!isView" icon="el-icon-circle-check" type="primary" :loading="loading" @click="handleSubmit">确 定</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('update:visible', false)">关 闭</el-button>
    </span>
  </div>
</template>

<script>
import {handleProblem} from "@/api/handover-inspection/passing-manage";
import MatrixUploadNoAction from "@/components/matrix/matrix-upload-no-action.vue";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import {getSysConfig, jsonToFormData} from "@/util/util";

export default {
  name: "handle-error",
  components: {MatrixUploadNoAction},
  props: {
    visible: Boolean,
    info: Object,
    viewType: String, // edit(处理)/view(查看)
  },
  data() {
    return {
      loading: false,
      isView: this.viewType === 'view', // 是否查看弹窗
      formData: {},
      formOption: {
        menuBtn: false,
        span: 24,
        labelWidth: 73,
        gutter: 20,
        column: [
          {
            label: "序号",
            prop: "problemSerial",
            disabled: true,
            span: 12
          },
          {
            label: "标记类型",
            prop: "flagName",
            disabled: true,
            span: 12
          },
          {
            label: "异常类型",
            prop: "problemTypeLabel",
            disabled: true,
          },
          {
            label: "异常图片",
            prop: "errImg",
            labelPosition: 'top'
          },
          {
            label: "上传凭证",
            prop: "voucher",
            span: 12,
          },
          {
            label: "备注",
            prop: "remark",
            type: 'textarea',
            maxlength: 100,
            disabled: this.viewType === 'view',
          },
        ]
      },
      voucherList: [], // 上传的凭证
      voucherImg: [], // 详情展示凭证
      processed: false, // 是否已处理
    }
  },
  created() {
    this.initFormData()
  },
  methods: {
    initFormData() {
      const {problemX1, problemY1, problemX2, problemY2, dealStatus, remark = ''} = this.info
      this.formData = this.deepClone(this.info)
      this.processed = Number(dealStatus) !== 0
      // 与原图比例是8
      const obj = {
        problemX1: parseInt(problemX1 / 8),
        problemY1: parseInt(problemY1 / 8),
        problemX2: parseInt(problemX2 / 8),
        problemY2: parseInt(problemY2 / 8),
        remark
      }
      // 计算标记宽高
      const w = parseInt(obj.problemX2 - obj.problemX1)
      const h = parseInt(obj.problemY2 - obj.problemY1)
      obj.width = Math.abs(w)
      obj.height = Math.abs(h)
      this.formData = {...this.formData, ...obj}

      const baseUrl = getSysConfig('CHECK_MINIO')

      this.getImageUrl(this.formData.imgSrc.replace(baseUrl,''),'check').then(res => {
        this.formData.imgSrc = res
      })

      this.voucherImg = []
      if(this.info.photo && this.info.photo) {

        this.voucherImg = []
        this.info.photo.split(',').forEach(item =>{
          this.getImageUrl(item,'check').then(res => {
            this.voucherImg.push(res)
          })
        })
      }
    },
    // 提交处理
    handleSubmit() {
      let {id: problemId, remark} = this.formData
      if (!remark) remark = ''
      this.loading = true
      if (!this.voucherList.length) { // 未上传凭证
        const params = {problemId, remark}
        handleProblem(jsonToFormData(params)).then(() =>{
          this.handleSuccess()
        }).finally(() => {
          this.loading = false
        })
      } else {
        // 有几个文件就调几次接口
        const reqArr = []
        this.voucherList.forEach(item => {
          const params = {problemId, remark, file: item.raw}
          reqArr.push(handleProblem(jsonToFormData(params)))
        })
        Promise.any(reqArr).then(() => {
          this.handleSuccess()
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handleSuccess() {
      this.$message.success('操作成功')
      this.$emit('afterSubmit')
    }
  }
}
</script>

<style scoped lang="scss">
.resizable-div {
  position: relative;
  width: 1000px;
  height: 256px;

  .image {
    width: 1000px;
    height: 256px;
    position: absolute;
    left: 0;
    top: 0;
    user-select: none;
    margin: 0 auto;
  }

  .draggable {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.my-class {
  border: 1px solid red;
}

.success-class {
  border: 1px solid rgba(0, 255, 0, .3);
}
</style>
